module.exports = __webpack_public_path__ + "img/logo-jmof_white.f83c1e58.svg";